import React from 'react';
import { useTranslation } from 'react-i18next';
import { Highlight } from 'react-instantsearch';

import type { SearchAllContentPageHit } from '../../types';
import Card from '../../../Card';

const SearchAllContentResultsPageHit: React.FC<{ hit: SearchAllContentPageHit }> = ({ hit }) => {
  const { t } = useTranslation();

  return (
    <Card
      className="SearchAllContent__Results__hit"
      url={hit.url[0]}
      label={t(`content_types.${hit.type[0]}.type`)}
      labelIcon="sort"
      title={<Highlight attribute="title" hit={hit} />}
    />
  );
};

export default SearchAllContentResultsPageHit;
